import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { ReportForm } from "../components";

export const CreateReport: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  return (
    <>
      <Header
        title="Rapport SEO"
        subtitle="Enregistrer un nouveau rapport"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/reports`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouveau rapport" />
          <ReportForm
            customerId={customerId ? +customerId : undefined}
            onCompleted={() => navigate("/reports")}
          />
        </div>
      </div>
    </>
  );
};
